"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var mat4 = require('gl-matrix/src/gl-matrix/mat4');
var CHUNK_SIZE = 32;
var Chunk = (function () {
    function Chunk(data, p0, p1, p2) {
        this.data = data;
        this.position = vec3.fromValues(p0, p1, p2);
        this.offset = vec3.fromValues(this.position[0] * CHUNK_SIZE, this.position[1] * CHUNK_SIZE, this.position[2] * CHUNK_SIZE);
        this.modelMatrix = mat4.fromTranslation(mat4.create(), this.offset);
        this.vaoNeedsToUpdate = true;
    }
    Chunk.prototype.get = function (x, y, z) {
        return this.data.get(x, y, z);
    };
    Chunk.prototype.set = function (x, y, z, val) {
        this.vaoNeedsToUpdate = true;
        return this.data.set(x, y, z, val);
    };
    Chunk.prototype.getVao = function (mesher) {
        if (this.vaoNeedsToUpdate) {
            this.vao = mesher.createVoxelMesh(this.data);
            this.vaoNeedsToUpdate = false;
        }
        return this.vao;
    };
    return Chunk;
}());
exports.Chunk = Chunk;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Chunk;
//# sourceMappingURL=Chunk.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/Chunk.js
 ** module id = 333
 ** module chunks = 0
 **/